const fetchStatusTranslations = ({ http }) => http.get('/dictionaries/application-statuses?languageCode=pl')
  .then(({ data }) => data
    .map(({ code, name }) => ({
      name,
      code
    }))
    .reduce((previous, current) => ({
      ...previous,
      [current.code]: current.name
    }), {}));

export default fetchStatusTranslations;
